import React from "react";
import styles from './TopTitle.module.scss';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';

export interface ITopTitleProps {
  title?: any;
  children?: any;
  loading?: boolean;
}

const TopTitle = ({loading, ...props}: ITopTitleProps) => (
  <h2 className={styles.topTitle}>
    {loading ? <SkeletonPlaceHolder
      variant="text"
      width={200}
      height={32}
    /> : props.title || props.children}
  </h2>
);

TopTitle.defaultProps = {
  loading: false
};

export default TopTitle;
